import Snackbar from 'awesome-snackbar';

// 👇️ handler to display snack bar
export const displaySnackbar = (
    msg = 'Message',
    isError = true,
    actionText = 'Ok',
    action = () => {}
) => {
    let my_snackbar = new Snackbar(msg, {
        actionText,
        onAction: () => {
            my_snackbar.hide();
            action();
        },
        position: 'top-center',
        timeout: 0,
        style: {
            container: [
                ['padding', '1.5rem 2.5rem'],
                // ['background-color', isError ? 'orange' : ''],
            ],
            message: [['color', isError ? 'orange' : '']],
            actionButton: [['color', isError ? 'orangered' : 'green']],
        },
    });
};
